import { useQuery } from '@apollo/client';

import {
  GetRdBusinessComponentUploadsQuery,
  GetRdBusinessComponentUploadsQueryVariables,
  GET_RD_BUSINESS_COMPONENT_UPLOADS,
  RdBusinessComponentUploadFragment,
} from '@neo.tax/shared';

export interface UseRdBusinessComponentUploads {
  uploads: RdBusinessComponentUploadFragment[];
  loading: boolean;
}

export const useRdBusinessComponentUploads = (fiscalYearId: string): UseRdBusinessComponentUploads => {
  const { data, loading } = useQuery<GetRdBusinessComponentUploadsQuery, GetRdBusinessComponentUploadsQueryVariables>(
    GET_RD_BUSINESS_COMPONENT_UPLOADS,
    { variables: { fiscalYearId } },
  );

  return { uploads: data?.getRdBusinessComponentUploads ?? [], loading };
};
